import { Component, Input, Inject, ChangeDetectionStrategy } from '@angular/core';

import * as Tokens from '@shared/core/tokens';

@Component({
    selector: 'shared-auth-balance-value',
    templateUrl: './auth-balance-value.shared.component.html',
    styleUrls: ['./auth-balance-value.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthBalanceValueComponent {
    @Input() public value!: number;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
    ) { }

    public get showValue(): boolean {
        return this.value !== undefined ? this.config.accountCharge?.balanceDisplayThreshold > this.value : false;
    }
}
